import { useEffect, useState } from "react";

type CookiePrefs = {
  necessary: boolean;
  analytics: boolean;
  marketing: boolean;
};

const STORAGE_KEY = "cookie-consent-preferences";

const defaultPrefs: CookiePrefs = {
  necessary: true,
  analytics: false,
  marketing: false,
};

const CookiesPage = () => {
  const [prefs, setPrefs] = useState<CookiePrefs>(defaultPrefs);
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (raw) setPrefs({ ...defaultPrefs, ...JSON.parse(raw) });
    } catch {}
  }, []);

  function save(newPrefs: CookiePrefs) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(newPrefs));
      setSaved(true);
      window.setTimeout(() => setSaved(false), 1500);
      try {
        window.dispatchEvent(new CustomEvent('cookie-consent-updated', { detail: newPrefs }));
      } catch {}
    } catch {}
  }

  return (
    <div className="container mx-auto px-4 py-10 max-w-3xl">
      <h1 className="text-3xl font-bold mb-6">Préférences cookies</h1>
      <p className="text-muted-foreground mb-6">
        Gérez ici vos préférences de consentement. Les cookies nécessaires sont toujours actifs pour des raisons
        de sécurité et de fonctionnement (authentification, prévention de fraude, préférence de consentement).
      </p>

      <div className="space-y-6">
        <section className="border border-border rounded-lg p-4">
          <h2 className="text-lg font-semibold">Nécessaires</h2>
          <p className="text-sm text-muted-foreground">Toujours actifs</p>
          <ul className="list-disc pl-6 mt-2 text-sm text-muted-foreground">
            <li>Session d'authentification Firebase</li>
            <li>Préférence de consentement aux cookies</li>
            <li>Sécurité et prévention d'abus</li>
          </ul>
        </section>

        <section className="border border-border rounded-lg p-4 flex items-start justify-between gap-4">
          <div>
            <h2 className="text-lg font-semibold">Analyse d'usage</h2>
            <p className="text-sm text-muted-foreground">Mesure d'audience pour améliorer le produit (désactivé par défaut).</p>
          </div>
          <label className="inline-flex items-center gap-2 select-none">
            <input
              type="checkbox"
              className="h-4 w-4"
              checked={prefs.analytics}
              onChange={(e) => setPrefs((p) => ({ ...p, analytics: e.target.checked }))}
            />
            <span className="text-sm">Autoriser</span>
          </label>
        </section>

        <section className="border border-border rounded-lg p-4 flex items-start justify-between gap-4">
          <div>
            <h2 className="text-lg font-semibold">Marketing</h2>
            <p className="text-sm text-muted-foreground">Personnalisation et retargeting (désactivé par défaut).</p>
          </div>
          <label className="inline-flex items-center gap-2 select-none">
            <input
              type="checkbox"
              className="h-4 w-4"
              checked={prefs.marketing}
              onChange={(e) => setPrefs((p) => ({ ...p, marketing: e.target.checked }))}
            />
            <span className="text-sm">Autoriser</span>
          </label>
        </section>

        <div className="flex items-center gap-3">
          <button
            className="px-4 py-2 rounded-md bg-primary text-primary-foreground hover:opacity-90"
            onClick={() => save(prefs)}
          >
            Enregistrer mes préférences
          </button>
          {saved ? <span className="text-sm text-muted-foreground">Préférences enregistrées.</span> : null}
        </div>
      </div>
    </div>
  );
};

export default CookiesPage;


